import React, { useContext, useEffect, useState } from "react";
import Style from "./style.module.css";
import InnerLoader from "../../../../component/ui/loader/inner-loader";
import DataNotFound from "../../../../component/ui/loader/data-not-found";
import { useApiCall } from "../../../../component/custom-hooks/api-call";
import DynamicFilter from "../../../../component/table/filter-table/dynamic-filter";
import FilterFunnel01Icon from "../../../../component/icons/filter-funnel-01";
import { Table, TableBody, TableCard, TableCell, TableDepartmentTag, TableFilterReturn, TableFooter, TableHead, TableHeaderWrap, TableRow, } from "../../../../component/table/table-layout";
import CustomizeTabsPopup from "../../../../component/table/customize-table";
import Tooltip from "../../../../component/ui/tooltip";
import LayoutTopIcon from "../../../../component/icons/layout-top";
import StatusChip from "../../../../component/ui/chip/status";
import { TitleHeading } from "../../../../component/ui/layout";
import { GlobalContext } from "../../../../context/Context";
import NewEditIcon from "../../../../component/icons/action-edit-icon";
import MainPopup from "../../../../component/popup/main";
import { ChevronDown, ChevronUp, Layers, List } from "lucide-react";
import { Alert, Snackbar } from "@mui/material";
import { CurrencyDollarCircle } from "../../../../component/table/filter-table/icons";
import { Brand, Clicks, Conversions, CostPerLead, Cpa, Cpc, Ctr, DateRange, FreshRoi, Impressions, Leads, OperationName, Platform, ProfitIcon, Revenue, Roas, TotalRoi, TotalUpsell } from "../../../../component/icons/filter-icon";

const PPCDataList = () => {
  let { state } = useContext(GlobalContext);
  const apiCall = useApiCall();
  const [isLoading, setIsLoading] = useState(true);
  const [lists, setList] = useState([]);
  const [showModalFilterTable, setShowModalFilterTable] = useState(false);
  const [filterReturn, setFilterReturn] = useState([]);
  const [saveFilter, setSaveFilter] = useState([]);
  const [tableHeaders, setTableHeaders] = useState([]);
  const [showModalCustomizeTabs, setShowModalCustomizeTabs] = useState(false);
  const [currentList, setCurrentList] = useState({});
  const [showPopup, setShowPopup] = useState(false);
  const [stagge, setStagge] = useState(false);
  const [staggeLoader, setStaggeLoader] = useState(true);
  const [footer, setFooter] = useState({})

  useEffect(() => {
    getData({ Stagge: stagge });
  }, []);

  const getData = async ({ filter = filterReturn, Stagge = stagge }) => {
    setIsLoading(true);

    let extraUrl = `${Stagge ? 'get-list-ppc-data' : 'get-list-ppc-data-group-by-date'}?`;

    for (let i = 0; i < filter?.length; i++) {
      if (filter[i]?.selectedOpt == "between") {
        extraUrl += `&${filter[i]?.name}=${filter[i]?.value[0]}_${filter[i]?.value[1]}`;
      } else {
        extraUrl += `&${filter[i]?.name}=${filter[i]?.value}`;
      }
    }
    try {
      const res = await apiCall({ method: "get", url: extraUrl });
      setList(res.data);
      setTableHeaders(res.headers);
      setSaveFilter(res?.custom_filters);
      setFooter(Stagge ? res?.footer : res?.overall_footer)
      setIsLoading(false);
      setStaggeLoader(false);
    } catch (error) {
      console.warn("Error : ", error);
    }
  };

  const filterModalData = [
    {
      name: "service_id",
      label: "Service",
      options: ["is"],
      selectedOpt: "is",
      value: "",
      type: "dropdown",
      dropdown: state.getDropdowns.serviceList,
      dropdownKey: "name",
      dropdownVal: "id",
      Icon: OperationName
    },
    {
      name: "brand_id",
      label: "Brand",
      options: ["is"],
      selectedOpt: "is",
      value: "",
      type: "dropdown",
      dropdown: state.getDropdowns.brandList,
      dropdownKey: "name",
      dropdownVal: "id",
      Icon: Brand
    },
    {
      name: "device",
      label: "Device",
      options: ["is"],
      selectedOpt: "is",
      value: "",
      type: "dropdown",
      dropdown: [
        { label: "Desktop", val: "Desktop" },
        { label: "Mobile", val: "Mobile" },
      ],
      dropdownKey: "label",
      dropdownVal: "val",
      Icon: TotalRoi
    },
    {
      name: "platform_id",
      label: "Platform",
      options: ["is"],
      selectedOpt: "is",
      value: "",
      type: "dropdown",
      dropdown: state.getDropdowns.platforms,
      dropdownKey: "name",
      dropdownVal: "id",
      Icon: Platform
    },
    {
      name: "clicks",
      label: "Number Of Clicks",
      options: ["between"],
      selectedOpt: "between",
      value: "",
      type: "number",
      betweenType: "number",
      Icon: Clicks
    },
    {
      name: "impressions",
      label: "Number Of Impressions",
      options: ["between"],
      selectedOpt: "between",
      value: "",
      type: "number",
      betweenType: "number",
      Icon: Impressions
    },
    {
      name: "ad_spend",
      label: "Ad Spend",
      options: ["between"],
      selectedOpt: "between",
      value: "",
      type: "number",
      betweenType: "number",
      Icon: Roas
    },
    {
      name: "conversions",
      label: "Conversions",
      options: ["between"],
      selectedOpt: "between",
      value: "",
      type: "number",
      betweenType: "number",
      Icon: Conversions
    },
    {
      name: "revenue",
      label: "Revenue",
      options: ["between"],
      selectedOpt: "between",
      value: "",
      type: "number",
      betweenType: "number",
      Icon: Revenue
    },
    {
      name: "date_range",
      label: "Date Range",
      options: ["between"],
      selectedOpt: "between",
      value: "",
      type: "date",
      betweenType: "date",
      Icon: DateRange
    },
    {
      name: "operation_by_name",
      label: "Operation Name",
      options: ["is"],
      selectedOpt: "is",
      value: "",
      type: "dropdown",
      dropdown: state.getDropdowns?.marketingMembers?.map((el) => ({
        label: el?.employee_name,
        val: el?.employee_id,
      })),
      dropdownKey: "label",
      dropdownVal: "val",
      Icon: OperationName
    },
    {
      name: "leads",
      label: "Leads",
      options: ["between"],
      selectedOpt: "between",
      value: "",
      type: "number",
      betweenType: "number",
      Icon: Leads
    },
    {
      name: "total_upsell",
      label: "Total Upsell",
      options: ["between"],
      selectedOpt: "between",
      value: "",
      type: "number",
      betweenType: "number",
      Icon: TotalUpsell
    },
    {
      name: "profit_loss",
      label: "Profit",
      options: ["between"],
      selectedOpt: "between",
      value: "",
      type: "number",
      betweenType: "number",
      Icon: ProfitIcon
    },
    {
      name: "cost_per_lead",
      label: "Cost Per Lead",
      options: ["between"],
      selectedOpt: "between",
      value: "",
      type: "number",
      betweenType: "number",
      Icon: CostPerLead
    },
    {
      name: "fresh_roi",
      label: "Fresh ROI",
      options: ["between"],
      selectedOpt: "between",
      value: "",
      type: "number",
      betweenType: "number",
      Icon: FreshRoi
    },
    {
      name: "total_roi",
      label: "Total ROI",
      options: ["between"],
      selectedOpt: "between",
      value: "",
      type: "number",
      betweenType: "number",
      Icon: TotalRoi
    },
    {
      name: "ctr",
      label: "CTR",
      options: ["between"],
      selectedOpt: "between",
      value: "",
      type: "number",
      betweenType: "number",
      Icon: Ctr
    },
    {
      name: "cpc",
      label: "CPC",
      options: ["between"],
      selectedOpt: "between",
      value: "",
      type: "number",
      betweenType: "number",
      Icon: Cpc
    },
    {
      name: "roas",
      label: "ROAS",
      options: ["between"],
      selectedOpt: "between",
      value: "",
      type: "number",
      betweenType: "number",
      Icon: Roas
    },
    {
      name: "cpa",
      label: "CPA",
      options: ["between"],
      selectedOpt: "between",
      value: "",
      type: "number",
      betweenType: "number",
      Icon: Cpa
    }
  ];

  const editList = (list) => {
    setCurrentList(list);
    setShowPopup(true);
  }

  const checkStagge = (e) => {
    setIsLoading(true);
    setStaggeLoader(true);
    let s = !e;
    setStagge(!e);

    setTimeout(() => {
      getData({ filter: filterReturn, Stagge: s });
    }, 300);
  }

  const [openGroups, setOpenGroups] = useState({});
  const toggleGroup = (index) => {
    setOpenGroups((prev) => ({
      ...prev,
      [index]: !prev[index]
    }));
  };

  const [alertData, setAlertData] = useState({ isShow: false });
  const handleClose = () => {
    setAlertData({ isShow: false })
  }
  const onSuccess = (message) => {
    setAlertData({ isShow: true, type: "success", message: message });
  };

  const onApplyError = (message) => {
    setAlertData({ isShow: true, type: "error", message: message })
  }

  return (
    <>
      <div className={Style.leaveMainPage}>
        <TableFilterReturn
          filterReturn={filterReturn}
          onChange={(filters) => {
            setFilterReturn(filters);
            getData({ filter: filters });
          }}
        />
        <div className={Style.report_table__header}>
          <TitleHeading title={'PPC Daily Data'} />

          <div className={Style.bpfl_action}>
            <Tooltip
              className={Style.bpfl_actionItems}
              content={`${stagge ? "Group By Date" : "List View"}`}
              position={"bottom center"}
            >
              <div
                className={`${Style.bpfl_actionBtn} ${staggeLoader ? "pointer-events-none -z-50" : ""}`}
                onClick={() => { checkStagge(stagge); }}
              >
                <div className={Style.icon}>
                  {
                    staggeLoader ? (
                      <InnerLoader textStatus={false} className={'!w-[1em] !h-[1em] !border-[1px]'} />
                    ) : (
                      stagge ? <Layers size="1em" /> : <List size="1em" />
                    )
                  }
                </div>
              </div>
            </Tooltip>

            <Tooltip
              className={Style.bpfl_actionItems}
              content={"Table Filter"}
              position={"left center"}
            >
              <div
                className={`${Style.bpfl_actionBtn} ${filterReturn?.length ? Style.active : null}`}
                onClick={() => { setShowModalFilterTable(true); }}
              >
                <div className={Style.icon}>
                  <FilterFunnel01Icon />
                </div>
              </div>
            </Tooltip>

            <div className={`${Style.bpfl_action}`}>
              <Tooltip
                className={`${Style.bpfl_actionItems}`}
                content={"Customize Table"}
                position={"left center"}
              >
                <div
                  className={`${Style.bpfl_actionBtn}`}
                  onClick={() => {
                    setShowModalCustomizeTabs(true);
                  }}
                >
                  <div className={Style.icon}>
                    <LayoutTopIcon />
                  </div>
                </div>
              </Tooltip>
            </div>
          </div>
        </div>

        <div className={Style.LeaveBody}>
          {isLoading ? (
            <InnerLoader />
          ) : !lists?.length ? (
            <div className="w-full h-full flex items-center justify-center">
              <DataNotFound title={"Lists"} />
            </div>
          ) : (
            stagge ? (
              <TableCard>
                <Table>
                  <TableHead>
                    <TableRow>
                      <TableCell header sticky><TableHeaderWrap>Brand Name</TableHeaderWrap></TableCell>
                      {tableHeaders?.map((eachHead, index) =>
                        eachHead.is_visible === 1 && eachHead?.show == 1 ? (
                          <TableCell header key={index}>
                            <TableHeaderWrap>
                              <span>{eachHead?.value}</span>
                            </TableHeaderWrap>
                          </TableCell>
                        ) : null
                      )}
                    </TableRow>
                  </TableHead>

                  <TableBody>
                    {lists?.map((eachList, index) => {
                      return (
                        <TableRow key={`cars_${index}`}>
                          <TableCell sticky>
                            {/* <AvatarProfile src={eachList?.profile_picture} title={eachList?.assigned_user} /> */}
                            {/* <div className="font-medium leading-5">{eachList?.brand_name}</div> */}
                            <div className={Style.tableActionArea}>
                              <div className="flex items-center gap-3">
                                <div>
                                  <div className="font-medium leading-5">
                                    {eachList?.brand_name}
                                  </div>
                                </div>
                              </div>

                              <div className={Style.tableActionAreaBtnGrpup}>
                                <div
                                  className={
                                    "w-7 h-7 flex items-center justify-center rounded-md bg-[rgba(255,255,255,0.2)] shadow-[0_4px_12px_rgba(0,0,0,0.08)] border border-gray-100 hover:scale-105 transition-transform duration-300"
                                  }
                                  onClick={() => {
                                    editList(eachList);
                                  }}
                                >
                                  <div
                                    className={Style.icon}
                                    style={{ color: "#FF9500" }}
                                  >
                                    <NewEditIcon className="h-4.5 w-4.5" />
                                  </div>
                                </div>
                              </div>
                            </div>
                          </TableCell>

                          {tableHeaders?.map((eachHead, i) =>
                            eachHead.is_visible === 1 && eachHead?.show == 1 ? (
                              <>
                                {eachHead.key === "status" ? (
                                  <TableCell key={`${i}-${index}`}>
                                    <StatusChip color={eachList[eachHead.key] === "Active" ? "green" : "red"}>
                                      {eachList[eachHead.key] || "--"}
                                    </StatusChip>
                                  </TableCell>
                                ) : eachHead.key === "assigned_user_department" ? (
                                  <TableCell key={`${i}-${index}`}>
                                    <TableDepartmentTag title={eachList[eachHead.key]} />
                                  </TableCell>
                                ) : eachHead.key === "service_name" ? (
                                  <TableCell key={`${i}-${index}`}>
                                    <TableDepartmentTag array={state?.getDropdowns?.serviceList} title={eachList[eachHead.key]} />
                                  </TableCell>
                                ) : eachHead.key === "platform_name" ? (
                                  <TableCell key={`${i}-${index}`}>
                                    <TableDepartmentTag colorIndex={6 - Number(state?.getDropdowns?.platforms?.find((e) => e?.name === eachList[eachHead.key])?.id ?? 8)} title={eachList[eachHead.key]} />
                                  </TableCell>
                                ) : eachHead.key === "device" ? (
                                  <TableCell key={`${i}-${index}`}>
                                    <TableDepartmentTag colorIndex={eachList[eachHead.key] === "Desktop" ? 15 : eachList[eachHead.key] === "Mobile" ? 12 : 13} title={eachList[eachHead.key]} />
                                  </TableCell>
                                ) : (
                                  <TableCell key={`${i}-${index}`}>
                                    {(eachHead?.key == "profit_loss" || eachHead?.key == "fresh_roi" || eachHead?.key == "total_roi") ?
                                      <span className={eachList[eachHead?.key]?.includes("-") ? "text-red-500" : (eachList[eachHead?.key] == "$0.00" || eachList[eachHead?.key] == "0.00%") ? "" : "text-green-500"}>{eachList[eachHead?.key]}</span>
                                      :
                                      eachList[eachHead?.key] ?? "-"
                                    }
                                  </TableCell>
                                )
                                }
                              </>
                            ) : null
                          )}
                        </TableRow>
                      );
                    })}
                  </TableBody>

                  <TableFooter>
                    <TableRow>
                      <TableCell header sticky className="!font-bold !bg-[#f6f7f7]">Summary</TableCell>
                      {tableHeaders?.map((head, hIdx) => {
                        return (
                          head.is_visible === 1 && head.show == 1 ? (
                            <TableCell header key={`footer_cell_${hIdx}`} className="!font-bold !text-center !bg-[#f6f7f7]">
                              {head.key === "status" ? (
                                <StatusChip color={footer[head.key] === "Active" ? "green" : "red"}>
                                  {footer[head.key] || "--"}
                                </StatusChip>
                              ) : head.key === "assigned_user_department" ? (
                                <TableDepartmentTag title={footer[head.key]} />
                              ) : (head.key == "profit_loss" || head.key == "fresh_roi" || head.key == "total_roi") ? (
                                <span
                                  className={
                                    footer[head.key]?.includes("-") ? "text-red-500" : (footer[head.key] == "$0.00" || footer[head.key] == "0.00%") ? "" : "text-green-500"
                                  }
                                >
                                  {footer[head.key]}
                                </span>
                              ) : (
                                footer[head.key] ?? "-"
                              )}
                            </TableCell>
                          ) : null
                        )
                      }

                      )}
                    </TableRow>
                  </TableFooter>
                </Table>
              </TableCard>
            ) : (
              <TableCard>
                <Table>
                  <TableHead>
                    <TableRow>
                      <TableCell header sticky className={"!min-w-[280px]"}><TableHeaderWrap>Brand Name</TableHeaderWrap></TableCell>
                      {tableHeaders?.map((eachHead, index) =>
                        eachHead.is_visible === 1 && eachHead?.show == 1 ? (
                          <TableCell header key={index} className={"!min-w-[130px]"}>
                            <TableHeaderWrap>
                              <span>{eachHead?.value}</span>
                            </TableHeaderWrap>
                          </TableCell>
                        ) : null
                      )}
                    </TableRow>
                  </TableHead>

                  {lists?.map((eachList, index) => {
                    return (
                      <React.Fragment key={index}>
                        <TableBody>
                          {/* THIS IS HEADER */}
                          <TableRow
                            className="cursor-pointer"
                            onClick={() => toggleGroup(index)}
                          >
                            <TableCell sticky className={'!bg-[#ededf4] !font-bold'}>
                              <div className=" flex items-center gap-3">
                                {/* ICON AREA */}
                                <span className="flex items-center">
                                  {openGroups[index] ? (
                                    <ChevronUp size={18} />
                                  ) : (
                                    <ChevronDown size={18} />
                                  )}
                                </span>

                                <span>{eachList?.date}</span>
                              </div>
                            </TableCell>
                            <TableCell colSpan={999} className={'!bg-[#ededf4] !font-bold'}></TableCell>
                          </TableRow>

                          {/* THIS IS BODY */}
                          {openGroups[index] && (
                            eachList?.rows?.map((rowData, rowIdx) => (
                              <TableRow key={`body_${index}_${rowIdx}`}>
                                <TableCell sticky className={'w-[180px]'}>
                                  {/* <AvatarProfile src={eachList?.profile_picture} title={eachList?.assigned_user} /> */}
                                  {/* <div className="font-medium leading-5">{eachList?.brand_name}</div> */}
                                  <div className={Style.tableActionArea}>
                                    <div className="flex items-center gap-3">
                                      <div>
                                        <div className="font-medium leading-5">
                                          {rowData?.brand_name}
                                        </div>
                                      </div>
                                    </div>

                                    <div className={Style.tableActionAreaBtnGrpup}>
                                      <div
                                        className={
                                          "w-7 h-7 flex items-center justify-center rounded-md bg-[rgba(255,255,255,0.2)] shadow-[0_4px_12px_rgba(0,0,0,0.08)] border border-gray-100 hover:scale-105 transition-transform duration-300"
                                        }
                                        onClick={() => {
                                          editList({...rowData, date : eachList?.date});
                                        }}
                                      >
                                        <div
                                          className={Style.icon}
                                          style={{ color: "#FF9500" }}
                                        >
                                          <NewEditIcon className="h-4.5 w-4.5" />
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </TableCell>

                                {tableHeaders?.map((head, hIdx) =>
                                  head.is_visible === 1 && head.show == 1 ? (
                                    <TableCell key={`cell_${index}_${rowIdx}_${hIdx}`} className="text-center">
                                      {head.key === "status" ? (
                                        <StatusChip color={rowData[head.key] === "Active" ? "green" : "red"}>
                                          {rowData[head.key] || "--"}
                                        </StatusChip>
                                      ) : head.key === "assigned_user_department" ? (
                                        <TableDepartmentTag title={rowData[head.key]} />
                                      ) : head.key === "service_name" ? (
                                        <TableDepartmentTag array={state?.getDropdowns?.serviceList} title={rowData[head.key]} />
                                      ) : head.key === "platform_name" ? (
                                        <TableDepartmentTag colorIndex={6 - Number(state?.getDropdowns?.platforms?.find((e) => e?.name === rowData[head.key])?.id ?? 8)} title={rowData[head.key]} />
                                      ) : head.key === "device" ? (
                                        <TableDepartmentTag colorIndex={rowData[head.key] === "Desktop" ? 15 : rowData[head.key] === "Mobile" ? 12 : 13} title={rowData[head.key]} />
                                      ) : (head.key == "profit_loss" || head.key == "fresh_roi" || head.key == "total_roi") ? (
                                        <span
                                          className={
                                            rowData[head.key]?.includes("-") ? "text-red-500" : (rowData[head.key] == "$0.00" || rowData[head.key] == "0.00%") ? "" : "text-green-500"
                                          }
                                        >
                                          {rowData[head.key]}
                                        </span>
                                      ) : (
                                        rowData[head.key] ?? "-"
                                      )}
                                    </TableCell>
                                  ) : null
                                )}
                              </TableRow>
                            ))
                          )}

                          {/* THIS IS FOOTER */}
                          <TableRow>
                            <TableCell sticky className="text-center !font-bold !bg-[#f6f7f7]"></TableCell>
                            {tableHeaders?.map((head, hIdx) => {
                              return (
                                head.is_visible === 1 && head.show == 1 ? (
                                  <TableCell key={`footer_cell_${index}_${hIdx}`} className="text-center !relative !font-bold !bg-[#f6f7f7]">
                                    {head.key === "status" ? (
                                      <StatusChip color={eachList.footer[head.key] === "Active" ? "green" : "red"}>
                                        {eachList.footer[head.key] || "--"}
                                      </StatusChip>
                                    ) : head.key === "assigned_user_department" ? (
                                      <TableDepartmentTag title={eachList.footer[head.key]} />
                                    ) : (head.key == "profit_loss" || head.key == "fresh_roi" || head.key == "total_roi") ? (
                                      <span
                                        className={
                                          eachList.footer[head.key]?.includes("-") ? "text-red-500" : (eachList.footer[head.key] == "$0.00" || eachList.footer[head.key] == "0.00%") ? "" : "text-green-500"
                                        }
                                      >
                                        {eachList.footer[head.key]}
                                      </span>
                                    ) : (
                                      eachList.footer[head.key] ?? "-"
                                    )}
                                  </TableCell>
                                ) : null
                              )
                            }

                            )}
                          </TableRow>
                        </TableBody>

                        {/* GAP EXTRA ROW */}
                        <TableRow>
                          <TableCell colSpan={999} className={'p-3'}></TableCell>
                        </TableRow>
                      </React.Fragment>
                    )
                  })}

                  <TableFooter>
                    <TableRow>
                      <TableCell header sticky className="!font-bold !bg-[#f6f7f7]">Summary</TableCell>
                      {tableHeaders?.map((head, hIdx) => {
                        return (
                          head.is_visible === 1 && head.show == 1 ? (
                            <TableCell header key={`footer_cell_${hIdx}`} className="!font-bold !text-center !bg-[#f6f7f7]">
                              {head.key === "status" ? (
                                <StatusChip color={footer[head.key] === "Active" ? "green" : "red"}>
                                  {footer[head.key] || "--"}
                                </StatusChip>
                              ) : head.key === "assigned_user_department" ? (
                                <TableDepartmentTag title={footer[head.key]} />
                              ) : (head.key == "profit_loss" || head.key == "fresh_roi" || head.key == "total_roi") ? (
                                <span
                                  className={
                                    footer[head.key]?.includes("-") ? "text-red-500" : (footer[head.key] == "$0.00" || footer[head.key] == "0.00%") ? "" : "text-green-500"
                                  }
                                >
                                  {footer[head.key]}
                                </span>
                              ) : (
                                footer[head.key] ?? "-"
                              )}
                            </TableCell>
                          ) : null
                        )
                      }

                      )}
                    </TableRow>
                  </TableFooter>
                </Table>
              </TableCard>
            )
          )}
        </div>
      </div>

      {showModalFilterTable && (
        <DynamicFilter
          data={filterModalData}
          onClose={() => setShowModalFilterTable(false)}
          returnData={filterReturn}
          onSave={(filters) => {
            getData({ filter: filters });
            setShowModalFilterTable(false);
            setFilterReturn(filters);
          }}
          saveFilter={saveFilter}
          apiUrl={stagge ? 'get-list-ppc-data' : 'get-list-ppc-data-group-by-date'}
        />
      )}

      {showModalCustomizeTabs && (
        <CustomizeTabsPopup
          data={tableHeaders}
          onClose={() => {
            setShowModalCustomizeTabs(false);
          }}
          onPreview={(updatedHeaders) => {
            setTableHeaders(updatedHeaders);
          }}
          onSave={(saveHeaders) => {
            setTableHeaders(saveHeaders);
          }}
          apiUrl={stagge ? 'get-list-ppc-data' : 'get-list-ppc-data-group-by-date'}
        />
      )}

      {showPopup &&
        <MainPopup
          tabIndex={0}
          onClose={() => { setShowPopup(false); setCurrentList({}); }}
          data={currentList}
          onChange={() => { setShowPopup(false); setCurrentList({}); getData({ filterReturn, stagge }) }}
          onSuccess={(e) => { onSuccess(e) }}
          onError={(e) => { onApplyError(e) }}
        />
      }


      <Snackbar open={alertData?.isShow} autoHideDuration={3000} onClose={handleClose}>
        <Alert
          onClose={handleClose}
          severity={alertData?.type}
          variant="filled"
          sx={{ width: '100%' }}
        >
          {alertData?.message}
        </Alert>
      </Snackbar>
    </>
  );
};

export default PPCDataList;
